import type { StatesConfig } from 'xstate'
import type { TStep } from 'src/types'
import { getIntellioD70ResumeTarget } from 'cohorts/intl_d70/helpers/getIntellioD70ResumeTarget'
import { getComplianceVersion } from 'helpers/getComplianceVersion'
import { useZustandGlobalLocalStore } from 'zustandGlobalLocalStore'
import { PageId } from 'constants/pages'

const isComplianceFlow = (): boolean => getComplianceVersion() !== null

const isUpsellCheckout = (): boolean =>
  useZustandGlobalLocalStore.getState().checkoutContext === 'upsell'

export const getXStateConfigWoofzIntD70 = (
  pages: TStep[],
): StatesConfig<any, any, any> => ({
  initial: {
    always: [
      {
        target: getIntellioD70ResumeTarget(pages),
      },
    ],
  },
  ...pages.reduce(
    (acc, page, index) => ({
      ...acc,
      [page.pageId]: {
        on: {
          NEXT_FLOW_STEP: {
            target: pages[index + 1]?.pageId,
          },
          PREVIOUS_FLOW_STEP: {
            target:
              index - 1 >= 0 ? pages[index - 1].pageId : pages[index].pageId,
          },
          SKIP_ONE_STEP: {
            target:
              index + 2 < pages.length
                ? pages[index + 2].pageId
                : pages[index].pageId,
          },
          SKIP_ONE_STEP_BACK: {
            target:
              index - 2 >= 0 ? pages[index - 2].pageId : pages[index].pageId,
          },
          POST_PAYMENT_CONTINUE: {
            target: PageId.REGISTRATION_INTL_D70,
          },
          ...(page.pageId === PageId.OFFER_INTL_D70 && {
            NEXT_FLOW_STEP: [
              { cond: isComplianceFlow, target: PageId.CHECKOUT_INTL_D70 },
              { target: PageId.PAYMENT_INTL_D70 },
            ],
            POST_PAYMENT_CONTINUE: { target: PageId.UPSELL_INTL_D70 },
          }),
          ...(page.pageId === PageId.PAYMENT_INTL_D70 && {
            NEXT_FLOW_STEP: { target: PageId.UPSELL_INTL_D70 },
            PREVIOUS_FLOW_STEP: { target: PageId.OFFER_INTL_D70 },
            POST_PAYMENT_CONTINUE: { target: PageId.UPSELL_INTL_D70 },
          }),
          ...(page.pageId === PageId.CHECKOUT_INTL_D70 && {
            NEXT_FLOW_STEP: [
              { cond: isUpsellCheckout, target: PageId.REGISTRATION_INTL_D70 },
              { target: PageId.UPSELL_INTL_D70 },
            ],
            PREVIOUS_FLOW_STEP: [
              { cond: isUpsellCheckout, target: PageId.UPSELL_INTL_D70 },
              { target: PageId.OFFER_INTL_D70 },
            ],
            POST_PAYMENT_CONTINUE: [
              { cond: isUpsellCheckout, target: PageId.REGISTRATION_INTL_D70 },
              { target: PageId.UPSELL_INTL_D70 },
            ],
          }),
          ...(page.pageId === PageId.UPSELL_INTL_D70 && {
            NEXT_FLOW_STEP: [
              { cond: isUpsellCheckout, target: PageId.CHECKOUT_INTL_D70 },
              { target: PageId.REGISTRATION_INTL_D70 },
            ],
          }),
        },
      },
    }),
    {},
  ),
})
